import { EventGS, EventGSToken } from '../core/EventsGS';
import { WrapperGS, WrapperValued } from '../core/WrapperGS';
import { OptionGS } from './OptionGS';

export class SelectGS extends WrapperGS<HTMLSelectElement> implements WrapperValued
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "select";
    }

    private readonly _onChangeToken: EventGSToken<Event>;
    public readonly onChange: EventGS<Event>;

    constructor(el: HTMLSelectElement|string)
    {
        super(el);
        this._onChangeToken = new EventGSToken<Event>(() => { this.el.addEventListener('change', e => this._onChangeToken.invoke(e)); });
        this.onChange = new EventGS<Event>(this._onChangeToken);
    }

    public get value() { return this.el.value; }
    public set value(value: string) { this.el.value = value; }

    public get selectedIndex() { return this.el.selectedIndex; }
    public set selectedIndex(value: number) { this.el.selectedIndex = value; }

    public get selectedOption(): OptionGS | undefined {
        const option = this.el.selectedOptions.item(0);
        return option ? WrapperGS.Wrap(option) as OptionGS : undefined;
    }

    public get options(): OptionGS[] {
        return Array.from(this.el.options).map(o => WrapperGS.Wrap(o) as OptionGS);
    }

    public get disabled() { return this.el.disabled; }
    public set disabled(value: boolean) { this.el.disabled = value; }
}
WrapperGS.ExtendComponentsByHTMLElement(SelectGS);
